import React from "react";
import { Collapse, Button } from 'reactstrap';
import { FacetContainer } from "../../containers";
import { FacetboxProps } from "../../containers/FacetboxContainer";
import { Translation } from 'react-i18next';
import "./Facetbox.scss";

export type State = {
  isOpen: boolean;
  isMobile: boolean;
};

class FacetBox extends React.Component<FacetboxProps, State> {

  constructor(props: FacetboxProps) {
    super(props);

    let isMobile = this.isMobile();
    this.state = {
      isOpen: !isMobile,
      isMobile: isMobile
    };

    this.updateState = this.updateState.bind(this);
    this.toggleIsOpen = this.toggleIsOpen.bind(this);
  }

  componentDidMount() {
    window.addEventListener("FacetsLoaded", this.props.resetFilters, false);
  }

  isMobile() {
    return window.innerWidth <= 768;
  }

  updateState() {
    let isMobile = this.isMobile();
    this.setState({
      isOpen: !isMobile,
      isMobile: isMobile
    });
  }

  toggleIsOpen() {
    this.setState({
      isOpen: !this.state.isOpen
    });
    if (!this.state.isOpen) {
        // scroll a little bit, because of the footer. it is sometime in the way.
        window.setTimeout(() => {
            window.scrollBy({ top: 2, behavior: "smooth" });
        },
        250);
    }
  }

  getHeaderElement(count: number) {
    let finalElement;
    if (this.state.isMobile) {
      let filterTextElement = <Translation>{t => t("Filter")}</Translation>;

      // Remove below code for now.
      // Can be used again when we fix the auto close on scroll using mobile. 
    
      // let filterLabelElement = (this.state.isOpen)
      //   ? <span>{filterTextElement}</span>
      //   : <a onClick={this.toggleIsOpen} href="#">{filterTextElement}</a>;

      let resultsLabelElement = <span id="resultsLabel" hidden={this.state.isOpen}>
        <Translation>{t => t("({{count}} result)", { count: count })}</Translation>
      </span>;

      finalElement = <span>
        {filterTextElement}
        {resultsLabelElement}
      </span>;
    }
    else {
      let text = <Translation>{t => t("Filter")}</Translation>;
      finalElement = <span>{text}</span>;
    }

    return <div className="facetbox-header">
      <span className="facetbox-header-label">{finalElement}</span>
      <span className="facetbox-header-clear" hidden={!this.state.isOpen}>
        <a onClick={this.props.resetFilters}><Translation>{t => t('Reset Filters')}</Translation></a>
      </span>
    </div>
  }

  render() {
    window.addEventListener('resize', this.updateState);

    const { count } = this.props.results;
    let headerElement = this.getHeaderElement(count);

    return (
      <div className="facetbox-container" id="facetBox">
        {headerElement}
            <hr hidden={!this.state.isOpen} />
          <Collapse isOpen={this.isMobile() ? true : this.state.isOpen}>
          <Translation>{t => <FacetContainer facet="SalesSteps" displayName={t('Sales Steps')} />}</Translation>
          <Translation>{t => <FacetContainer facet="Topic" displayName={t('Topics')} />}</Translation>
          <Translation>{t => <FacetContainer facet="DocumentType" displayName={t('Document Types')} />}</Translation>
          <Translation>{t => <FacetContainer facet="Language" displayName={t('Languages')} />}</Translation>
          <Translation>{t => <FacetContainer facet="CloudSolutions" displayName={t('Preconfigured Cloud Solutions')} />}</Translation>
          <Translation>{t => <FacetContainer facet="Industries" displayName={t('Industries')} />}</Translation>
        </Collapse>


        {
        /* Remove below code for now.
        Can be used again when we fix the auto close on scroll using mobile. */
        }

        {
        /* <div className="facetbox-show-results-button">
          <Button hidden={!this.state.isMobile || !this.state.isOpen} onClick={this.toggleIsOpen}>
            <Translation>{t => t("Show {{count}} result", { count: count })}</Translation>
          </Button>
        </div> */
        }

      </div>
    );
  }
}

export default FacetBox;
